var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8006 2.2736C18.1149 2.57764 17.3774 2.78328 16.6038 2.87512C17.3936 2.40194 17.9997 1.65325 18.2858 0.759674C17.5468 1.19805 16.7279 1.51607 15.8572 1.68748C15.1595 0.944494 14.1655 0.480164 13.0649 0.480164C10.9532 0.480164 9.24045 2.19288 9.24045 4.30461C9.24045 4.60437 9.27439 4.89615 9.33999 5.17623C6.16155 5.0168 3.34334 3.49432 1.45693 1.1798C1.12779 1.74452 0.938978 2.40194 0.938978 3.10272C0.938978 4.42925 1.61465 5.60035 2.64029 6.286C2.01367 6.26632 1.42356 6.09434 0.908175 5.80713C0.907889 5.82339 0.907889 5.83964 0.907889 5.85561C0.907889 7.70866 2.22672 9.25424 3.97595 9.60534C3.65537 9.69318 3.31682 9.73967 2.96857 9.73967C2.72157 9.73967 2.48228 9.716 2.24897 9.67151C2.73555 11.1906 4.14765 12.2963 5.82158 12.3274C4.51244 13.3534 2.86361 13.9646 1.07132 13.9646C0.763285 13.9646 0.458105 13.9466 0.159485 13.9109C1.8511 14.9965 3.86186 15.6294 6.02151 15.6294C13.0561 15.6294 16.903 9.80185 16.903 4.74755C16.903 4.58184 16.8993 4.4167 16.8919 4.25299C17.6397 3.71393 18.288 3.04054 18.8006 2.2736Z",
    fill: "#F1F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f8f8f2657657e53691fb48e021408888.svg";
export { ForwardRef as ReactComponent };